import axios from '../lib/utils/axios_utils.js?vue3';
import { normalizeData } from 'ee_else_ce/repository/utils/commit';
import { createAlert } from '../alert.js?vue3';
import { logsFileProjectRefPath } from '~/lib/utils/path_helpers/repository';
import { encodeUrlHash } from '~/lib/utils/url_utility';
import { COMMIT_BATCH_SIZE, I18N_COMMIT_DATA_FETCH_ERROR } from './constants';

let requestedOffsets = [];
let fetchedBatches = [];

export const isRequested = (offset) => requestedOffsets.includes(offset);

export const resetRequestedCommits = () => {
  requestedOffsets = [];
  fetchedBatches = [];
};

const addRequestedOffset = (offset) => {
  if (isRequested(offset) || offset < 0) {
    return;
  }

  requestedOffsets.push(offset);
};

// eslint-disable-next-line max-params
const fetchData = (projectPath, path, ref, offset, refType) => {
  if (fetchedBatches.includes(offset) || offset < 0) {
    return [];
  }

  fetchedBatches.push(offset);

  // '#' also needs to be encoded because it can cause issues in GitLab repository URLs by being interpreted as a fragment identifier.
  const url = encodeUrlHash(logsFileProjectRefPath(projectPath, ref, path));

  return axios
    .get(url, { params: { format: 'json', offset, ref_type: refType } })
    .then(({ data }) => normalizeData(data, path))
    .catch(() => createAlert({ message: I18N_COMMIT_DATA_FETCH_ERROR }));
};

// Refetches every batch that was already loaded, e.g. after a path lock
// changes, so that server-provided fields like `lockLabel` stay accurate.
// eslint-disable-next-line max-params
export const reloadCommits = async (projectPath, path, ref, refType) => {
  const offsets = [...fetchedBatches];
  resetRequestedCommits();

  const commits = await Promise.all(
    offsets.map((offset) => {
      Array.from(Array(COMMIT_BATCH_SIZE)).forEach((_, i) => addRequestedOffset(offset + i));
      return fetchData(projectPath, path, ref, offset, refType);
    }),
  );

  return commits.flat();
};

// eslint-disable-next-line max-params
export const loadCommits = async (projectPath, path, ref, offset, refType) => {
  if (isRequested(offset)) {
    return [];
  }

  // We fetch in batches of 25, so this ensures we don't refetch
  Array.from(Array(COMMIT_BATCH_SIZE)).forEach((_, i) => addRequestedOffset(offset + i));

  const commits = await fetchData(projectPath, path, ref, offset, refType);

  return commits;
};
